import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconAlert: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 57 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M55.3817 37.3805L35.8461 4.5819V4.5819C33.2474 0.466344 27.8452 -0.737304 23.7799 1.8935C22.7126 2.58414 21.8065 3.50147 21.1243 4.5819L1.58861 37.3805L1.58861 37.3805C0.184045 39.7508 0.135497 42.6997 1.46126 45.116C2.9945 47.8367 5.85546 49.5115 8.94951 49.4995H48.0208C51.0938 49.5327 53.9499 47.9002 55.5091 45.2192C56.8745 42.7764 56.8258 39.7765 55.3817 37.3805ZM28.4852 39.1855C27.0785 39.1855 25.9382 38.031 25.9382 36.607C25.9382 35.1829 27.0785 34.0285 28.4852 34.0285C29.8919 34.0285 31.0322 35.1829 31.0322 36.607C31.0322 38.031 29.8919 39.1855 28.4852 39.1855ZM31.0322 28.8714C31.0322 30.2955 29.8919 31.45 28.4852 31.45C27.0785 31.45 25.9382 30.2955 25.9382 28.8714V18.5574C25.9382 17.1333 27.0785 15.9789 28.4852 15.9789C29.8919 15.9789 31.0322 17.1333 31.0322 18.5574V28.8714Z"
        fill="#333739"
      />
    </svg>
  </IconStyled>
);

IconAlert.defaultProps = iconDefaultProps;
IconAlert.displayName = 'IconAlert';

export default IconAlert;
